/* eslint-disable react/jsx-no-bind */
/* eslint-disable @scandipwa/scandipwa-guidelines/only-render-in-component */
/**
 * ScandiPWA - Progressive Web App for Magento
 *
 * Copyright © Scandiweb, Inc. All rights reserved.
 * See LICENSE for license details.
 *
 * @license OSL-3.0 (Open Software License ("OSL") v. 3.0)
 * @package scandipwa/scandipwa
 * @link https://github.com/scandipwa/scandipwa
 */

import PropTypes from 'prop-types';
import { PureComponent } from 'react';

import Link from 'Component/Link';
import { ChildrenType } from 'Type/Common.type';
import { scrollToTop } from 'Util/Helper';

import './PaginationLink.style';

/** @namespace Pwa/Component/PaginationLink/Component/PaginationLinkComponent */
export class PaginationLinkComponent extends PureComponent {
    static propTypes = {
        children: ChildrenType,
        label: PropTypes.string.isRequired,
        isCurrent: PropTypes.bool.isRequired,
        url_path: PropTypes.string.isRequired,
        pageNumber: PropTypes.number.isRequired,
        getSearchQueryForPage: PropTypes.func.isRequired
    };

    static defaultProps = {
        children: []
    };

    getSearchQueryForPage() {
        const { getSearchQueryForPage, pageNumber } = this.props;

        return getSearchQueryForPage(pageNumber);
    }

    render() {
        const {
            label,
            url_path: pathname,
            isCurrent,
            children
        } = this.props;

        const search = this.getSearchQueryForPage();

        const { state = {} } = history.state || {};

        return (
            <Link
              to={ {
                  search,
                  pathname,
                  state
              } }
              onClick={ () => scrollToTop() }
              aria-label={ label }
              block="PaginationLink"
              mods={ { isCurrent, isArrow: typeof children !== 'string' } }
              aria-current={ isCurrent ? 'page' : 'false' }
            >
                { children }
            </Link>
        );
    }
}

export default PaginationLinkComponent;
